/**
 * BSS Free Gift – Ultimate Price & Total Fix (B2B Compatible)
 * ====================================================================
 */
(function () {
  'use strict';

  var DEFAULT_CONFIG = {
    priceSelectors: [
      '.cart-item__price', '.cart-item__final-price', '[data-cart-item-price]',
      '[data-item-price]', '.price--end', '.product-option__price',
      '.line-item__price', '.cart__price', '.cart-line-price',
      '.cart-product__price', '.price', '[class*="price"]'
    ],
    giftPropertyKeys: [],
    debug: false,
  };

  function getConfig() {
    try {
      var u = window.BSSGiftPriceFixConfig || {};
      return {
        priceSelectors: u.priceSelectors || DEFAULT_CONFIG.priceSelectors,
        giftPropertyKeys: u.giftPropertyKeys || DEFAULT_CONFIG.giftPropertyKeys,
        debug: u.debug === true,
      };
    } catch (e) { return DEFAULT_CONFIG; }
  }

  function log() {
    try {
      if (getConfig().debug) console.log.apply(console, ['[BSS Gift Price Fix]'].concat(Array.prototype.slice.call(arguments)));
    } catch (e) {}
  }

  function formatMoney(cents, moneyFormat) {
    try {
      if (moneyFormat) {
        var amount = (cents / 100).toFixed(2);
        return moneyFormat
          .replace('{{amount}}', amount)
          .replace('{{amount_no_decimals}}', Math.round(cents / 100))
          .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
          .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
      }
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(navigator.language || 'it-IT', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) { return '\u20ac' + (cents / 100).toFixed(2); }
  }

  function parseMoneyToCents(text) {
    var cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return 0;
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    if (lastComma > lastDot) {
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else if (lastDot > lastComma) {
      cleaned = cleaned.replace(/,/g, '');
    }
    return Math.round(parseFloat(cleaned) * 100);
  }

  function isGiftItem(item) {
    try {
      var cfg = getConfig();
      var props = item.properties || {};
      if (cfg.giftPropertyKeys.length > 0) return cfg.giftPropertyKeys.some(function (k) { return Object.prototype.hasOwnProperty.call(props, k); });
      if (Object.keys(props).some(function (k) { return k.charAt(0) === '_'; })) return true;
      if (item.final_price === 0 && item.original_price > 0) return true;
      if (item.total_discount > 0 && item.final_price === 0) return true;
      return false;
    } catch (e) { return false; }
  }

  function findCartLineElement(item) {
    var selectors = [
      '[data-variant-id="' + item.variant_id + '"]', '[data-id="' + item.variant_id + '"]',
      '[data-key="' + item.key + '"]', '[data-line-key="' + item.key + '"]',
      '.cart-item[data-variant="' + item.variant_id + '"]',
    ];
    for (var i = 0; i < selectors.length; i++) {
      try { var el = document.querySelector(selectors[i]); if (el) return el; } catch (e) {}
    }
    return null;
  }

  function updatePriceElement(el, finalPrice, moneyFormat) {
    try {
      var cfg = getConfig();
      var formattedPrice = formatMoney(finalPrice, moneyFormat);
      for (var i = 0; i < cfg.priceSelectors.length; i++) {
        try {
          var priceEls = el.querySelectorAll(cfg.priceSelectors[i]);
          priceEls.forEach(function (priceEl) {
            var currentText = priceEl.textContent || priceEl.innerText || '';
            if (/[\d,.]/.test(currentText)) {
              var mainPrice = priceEl.querySelector('.price__regular, .price__sale, span:not(s):not(del)');
              if (mainPrice) mainPrice.textContent = formattedPrice;
              else priceEl.textContent = formattedPrice;
              if (priceEl.hasAttribute('data-price')) priceEl.setAttribute('data-price', finalPrice);
            }
          });
        } catch (e) {}
      }
    } catch (e) { console.warn('[BSS Gift Price Fix] updatePriceElement error:', e); }
  }

  function updateCartTotals(cart, giftDiscountCents, moneyFormat) {
    if (giftDiscountCents <= 0) return;

    try {
      var totalSelectors = [
        '.cart-page__total-value', '.cart-page__subtotal', '.cart-page__total',
        '[bss-b2b-cart-total-price]',
        '.totals__subtotal-value', '.cart-subtotal__price', '.cart__subtotal',
        '.cart-total-price', '.totals__total-value', '.cart__total',
        '#cart-total', '[data-cart-total]', '[data-cart-subtotal]',
        '.bss-b2b-cart-total', '.bss-b2b-subtotal', '.bss-b2b-total-price'
      ];

      var els = document.querySelectorAll(totalSelectors.join(', '));
      els.forEach(function (el) {
        var targetNode = el.querySelector('.bss-b2b-cart-total, .bss-b2b-price-has-vat, .money') || el;
        
        var originalText = targetNode.getAttribute('data-original-text');
        if (!originalText) {
            originalText = targetNode.textContent || '';
            targetNode.setAttribute('data-original-text', originalText);
        }

        if (/[\d,.]/.test(originalText)) {
          var currentTotalCents = parseMoneyToCents(originalText);
          
          if (currentTotalCents > 0) {
            // NẾU GIÁ TRÊN WEB ĐÃ BẰNG GIÁ THỰC CỦA GIỎ HÀNG (đã trừ quà) -> ĐÃ ĐÚNG, BỎ QUA!
            if (Math.abs(currentTotalCents - cart.total_price) <= 2) {
                return;
            }

            // NẾU GIÁ TRÊN WEB NHỎ HƠN GIÁ THỰC (Có thể do mã giảm giá B2B khác) -> BỎ QUA
            if (currentTotalCents < cart.total_price) {
                return;
            }

            // NẾU GIÁ TRÊN WEB LỚN HƠN -> CHẮC CHẮN BỊ CỘNG DƯ TIỀN QUÀ TẶNG
            // Ép con số về đúng giá trị thực của giỏ hàng (cart.total_price)
            var correctTotalCents = cart.total_price;
            var formattedCorrectTotal = formatMoney(correctTotalCents, moneyFormat);
            
            var correctNumberMatch = formattedCorrectTotal.match(/[\d,.]+/);
            var correctNumber = correctNumberMatch ? correctNumberMatch[0] : null;
            
            if (correctNumber) {
              var newText = originalText.replace(/[\d.,]+/, correctNumber);
              if (targetNode.textContent !== newText) {
                targetNode.textContent = newText;
              }
            }
          }
        }
      });
    } catch (e) { console.warn('[BSS Gift Price Fix] updateCartTotals error:', e); }
  }

  function fixByTitleMatch(item, moneyFormat) {
    try {
      var cartRows = document.querySelectorAll('.cart-item, [data-cart-item], .cart__item, .cart-line, .cart_item, tr.cart-line-item, [class*="cart-item"]');
      cartRows.forEach(function (row) {
        try {
          var text = row.textContent || '';
          var isMatch = (item.title && text.indexOf(item.title) !== -1) || (item.sku && item.sku.length > 0 && text.indexOf(item.sku) !== -1);
          if (isMatch) updatePriceElement(row, 0, moneyFormat);
        } catch (e) {}
      });
    } catch (e) {}
  }

  var fixInterval = null;

  function fixGiftPrices() {
    try {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var moneyFormat = (window.Shopify && window.Shopify.money_format) || null;

      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Content-Type': 'application/json' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function (cart) {
          var applyFix = function() {
            var items = cart.items || [];
            var giftDiscountCents = 0;

            items.forEach(function (item) {
              if (!isGiftItem(item)) return;
              
              giftDiscountCents += (item.price || item.original_price || 0) * item.quantity;

              if (item.final_price === 0) {
                var lineEl = findCartLineElement(item);
                if (lineEl) updatePriceElement(lineEl, 0, moneyFormat);
                else fixByTitleMatch(item, moneyFormat);
              }
            });

            updateCartTotals(cart, giftDiscountCents, moneyFormat);
          };

          applyFix();
          if (fixInterval) clearInterval(fixInterval);
          fixInterval = setInterval(applyFix, 500);
          setTimeout(function() { if (fixInterval) clearInterval(fixInterval); }, 10000);
        })
        .catch(function (e) { console.warn('[BSS Gift Price Fix] cart.js fetch error:', e); });
    } catch (e) { console.warn('[BSS Gift Price Fix] fixGiftPrices error:', e); }
  }

  function init() {
    try {
      fixGiftPrices();
      var cartEvents = ['cart:updated', 'cart:refresh', 'theme:cart:updated', 'cart-update', 'CART_UPDATE', 'sections:load'];
      cartEvents.forEach(function (eventName) {
        try {
          document.addEventListener(eventName, function () { setTimeout(fixGiftPrices, 200); });
          window.addEventListener(eventName, function () { setTimeout(fixGiftPrices, 200); });
        } catch (e) {}
      });

      if (typeof MutationObserver !== 'undefined') {
        var debounceTimer = null;
        var cartContainerSelectors = ['#cart-drawer', '#CartDrawer', '.cart-drawer', '#cart', '.cart', '[data-cart]', '#cart-items', '.cart__items', 'cart-items', 'cart-drawer-items'];
        var cartContainer = null;
        for (var i = 0; i < cartContainerSelectors.length; i++) {
          try { cartContainer = document.querySelector(cartContainerSelectors[i]); if (cartContainer) break; } catch (e) {}
        }
        new MutationObserver(function (mutations) {
          try {
            var hasChanges = mutations.some(function (m) { return m.addedNodes.length > 0 || m.type === 'characterData'; });
            if (!hasChanges) return;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(fixGiftPrices, 300);
          } catch (e) {}
        }).observe(cartContainer || document.body, { childList: true, subtree: true, characterData: true });
      }
    } catch (e) { console.warn('[BSS Gift Price Fix] init error:', e); }
  }

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  } catch (e) { console.warn('[BSS Gift Price Fix] Failed to initialize:', e); }
})();
